import { render, staticRenderFns } from "./CabinetManagement.vue?vue&type=template&id=072a34d7&scoped=true"
import script from "./CabinetManagement.vue?vue&type=script&lang=ts"
export * from "./CabinetManagement.vue?vue&type=script&lang=ts"
import style0 from "./CabinetManagement.vue?vue&type=style&index=0&id=072a34d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072a34d7",
  null
  
)

export default component.exports